import { logNewRelicPageAction } from '@makemydeal/dr-activities-common';
import type { TradeInIntelligenceCompletionServiceData } from '@makemydeal/dr-dash-types';

import { SOCKET_EVENT_IGNORED } from '../../actionTypes/socketActionTypes';
import { tradeInIntelligenceEventReceived, tradeInIntelligenceSubscribed } from '../tradeInIntelligenceActionCreators';
import * as offerReduxSelectors from '../../selectors/offerRedux';
import * as tradeInIntelligenceSelectors from '../../selectors/tradeInIntelligenceSelectors';
import { createLoggingContextSelector } from '../../selectors/loggingContextSelector';
import type { TopicHandler } from './types';

export const TRADE_IN_INTELLIGENCE_TOPIC = 'dealPulseTradeIn';

const tradeInIntelligenceLoggingContext = (state: any, event: any) => ({
    ...createLoggingContextSelector(state),
    eventTopic: event.topic,
    connectionId: event.connectionId
});

export const handleTradeInIntelligence: TopicHandler = (state, event) => {
    const slice = tradeInIntelligenceSelectors.getTradeInIntelligence(state);

    if (typeof event.message === 'string' && event.message.includes('subscribe')) {
        return slice.status === 'idle' ? tradeInIntelligenceSubscribed() : { type: SOCKET_EVENT_IGNORED, payload: event };
    }

    const completion = event.data as TradeInIntelligenceCompletionServiceData | undefined;

    const openDealXgId = offerReduxSelectors.getDealXgId(state);
    if (!openDealXgId || completion?.dealId !== openDealXgId) {
        logNewRelicPageAction('MV:TradeInIntelligence:WebSocketReceived:FanOutFiltered', {
            ...tradeInIntelligenceLoggingContext(state, event),
            reason: openDealXgId ? 'dealxgid_mismatch' : 'no_open_dealxgid'
        });
        return { type: SOCKET_EVENT_IGNORED, payload: event };
    }

    if (slice.status !== 'pending') {
        logNewRelicPageAction('MV:TradeInIntelligence:WebSocketReceived:NotPending', {
            ...tradeInIntelligenceLoggingContext(state, event),
            reason: slice.status === 'idle' ? 'never_requested' : 'already_settled'
        });
        return { type: SOCKET_EVENT_IGNORED, payload: event };
    }

    logNewRelicPageAction('MV:TradeInIntelligence:WebSocketReceived', {
        ...tradeInIntelligenceLoggingContext(state, event),
        outcome: completion.state,
        recordCount: completion.count,
        failureReason: completion.failureReason ?? null,
        requestId: completion.requestId ?? null,
        requestToRenderDelayMs: slice.requestedAtMs === null ? null : Date.now() - slice.requestedAtMs
    });

    return tradeInIntelligenceEventReceived(completion);
};
